const PREFIX = 'bravissimo/product-review/';

export const PURCHASED_SIZE_SELECTED = `${PREFIX}PURCHASED_SIZE_SELECTED`;
export const SUBMIT_FAILURE = `${PREFIX}SUBMIT_FAILURE`;
export const SUBMIT_REQUEST = `${PREFIX}SUBMIT_REQUEST`;
export const SUBMIT_SUCCESS = `${PREFIX}SUBMIT_SUCCESS`;
